var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex f-100 wrapped jc-center p-relative"},_vm._l((_vm.dates),function(date,index){return _c('WorkshiftCard',{key:index,attrs:{"date":date,"workshiftCardIndex":index,"service":_vm.service},on:{"change":_vm.changeHandler}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }